// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw Online 究極版',
  freeTimesLimitTitle: '無料体験は本日で終了となります。',
  fileSizeLimitTitle:
    '無料アカウントのファイルサイズは20MBを超えることはできません。',
  freeImgCutoutTimesLimitTitle:
    '今日の背景削除のトライアル回数がなくなったので、すべてのプレミアム機能にアクセスするにはProにアップグレードしてください。',
  total: '全て',
  enterCode: 'コードを入力する',
  signUpToPurchaseBtn: '登録して購入する',
  goPurchseBtn: '購入する',
  saveTips: '最大{{num}}％割引',
  discount: '割引',
  priceWeek: '999円',
  priceMonth: '820円',
  priceYear: '558円',
  billedMonth: '毎月課金 3,278円',
  billedYear: '毎年課金 26,799円',
  monthly: '毎月',
  yearly: '年間',
  weekly: '毎週',
  week: '週',
  AlreadySubscribe: 'すでに購読していますか?',
  vipTips1: 'ファイルサイズの制限なし',
  vipTips2: '無制限のファイル処理量',
  vipTips3: '画像背景を無制限に変更',
  vipTips4: 'すべての無料ツールとプレミアム機能を利用可能',
  purchaseTips: '契約は自動的に更新され、いつでも解約できます。',
  tips: 'ヒント',
  promoCodeInvalidTips: '販促コードが無限になりました。',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
